import { render, staticRenderFns } from "./KernelSubstrates.vue?vue&type=template&id=267e2b88&"
import script from "./KernelSubstrates.vue?vue&type=script&lang=js&"
export * from "./KernelSubstrates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports